import { combineReducers } from 'redux'

import { reducer as onboardingWizardSlice } from './ai_notetaker_wizard/wizard_slice'
import { reducer as loadingModal } from './components/wizard_modal_loader/wizard_modal_loader_slice'
import { reducer as autoShareDiscoveryModal } from './modals/auto_share_discovery_modal/auto_share_discovery_modal_slice'
import { reducer as recordingRulesModal } from './modals/recording_rules_modal/recording_rules_modal_slice'
import { reducer as acknowledgementModal } from './modals/wizard_acknowledgement_modal/acknowledgement_modal_slice'

export const reducer = combineReducers({
  acknowledgementModal,
  recordingRulesModal,
  autoShareDiscoveryModal,
  loadingModal,
  onboardingWizardSlice,
})
